import axios from "axios";
import localCache from "./localCache.js";

var ref = {};
var timeout = 10000; // default to 10 seconds

function _getCacheKeyForURLAndParams(url, params) {
  // generate unique key
  if (params && typeof params !== "undefined") {
    return escape(url + JSON.stringify(params));
  } else {
    return escape(url);
  }
}

function _fetchWithParams(dataURL, params) {
  return new Promise(function(resolve, reject) {
    axios
      .get(dataURL, {
        params: params,
        timeout: timeout
      })
      .then(function(response) {
        var result = response.data;
        if (result) {
          return resolve(result);
        }
        throw new Error("DataFetcher: Network requested FAILED.");
      });
  });
}

function _fetchThenValidateAndCache(dataURL, params, validateResultFn) {
  // return new Promise(function (resolve, reject) {
  var cacheKey = _getCacheKeyForURLAndParams(dataURL, params);
  var fetchParams = { params: params };
  if (
    params &&
    params.hasOwnProperty("timeout") &&
    typeof params.timeout !== "undefined"
  ) {
    fetchParams.timeout = Number(params.timeout);
    if (fetchParams.timeout <= 0) {
      fetchParams.timeout = 10000; // set default to 10 seconds
    }
  }

  console.log("DataFetcher: fetch dataURL = " + dataURL, params);
  console.log("DataFetcher: fetchParams = ", fetchParams);

  return axios
    .get(dataURL, fetchParams)
    .then(function(response) {
      var result = response.data;
      if (result && validateResultFn(result)) {
        _saveCacheForKeyAndValue(cacheKey, result);
        return result;
      } else if (result === null) {
        throw new Error("DataFetcher: Network requested result is null.");
      } else if (result && !validateResultFn(result)) {
        throw new Error("DataFetcher: Network requested result is not valid.");
      }
      throw new Error("DataFetcher: Network requested FAILED.");
    })
    .catch(function(error) {
      console.warn("DataFetcher: error = ", error);
      // either result is failed or result is not pass validate
      // then trying to return the latest one from cache, ignore expire date in here
      var recoverResult = _getCachedForKey(cacheKey);
      if (!recoverResult) {
        console.warn(
          "DataFetcher: no cached found for recover : " + dataURL,
          params
        );
        throw error;
      }
      console.log("recoverResult = ", recoverResult);
      return recoverResult;
    });
}

function _getCachedDataForURLParamsMaxAgeMinute(dataURL, params, maxAgeMinute) {
  var cacheKey = _getCacheKeyForURLAndParams(dataURL, params);
  var cachedData = _getCacheForKeyAndMaxAgeMinute(cacheKey, maxAgeMinute);
  if (cachedData) {
    console.log("DataFetcher: CACHE HIT!");
    return Promise.resolve(cachedData);
  } else {
    return Promise.resolve(null);
  }
}

function _getCacheForKeyAndMaxAgeMinute(key, maxAgeMinute) {
  // if not specific maxAgeMinute, set default to 5 mins
  if (typeof maxAgeMinute === "undefined" || maxAgeMinute === null) {
    maxAgeMinute = 5;
  }
  return localCache.getCachedForKeyWithMaxAge(key, maxAgeMinute * 60 * 1000);
}

function _saveCacheForKeyAndValue(key, value) {
  if (localCache.saveCacheForKeyAndValue(key, value) === false) {
    // failed to save to localStorage,
    // localCache will clearOldCache
    // so here we try to save again
    // after localCache has cleared some old cache
    return localCache.saveCacheForKeyAndValue(key, value);
  }
  return true;
}

function _getCachedForKey(key) {
  return localCache.getCachedForKey(key);
}

ref.fetchWithParams = _fetchWithParams;
ref.fetchThenValidateAndCache = _fetchThenValidateAndCache;
ref.getCachedDataForURLParamsMaxAgeMinute = _getCachedDataForURLParamsMaxAgeMinute;

export default ref;
